import { cn } from '@/shared/utils/cn';

interface PageHeaderProps {
  className?: string;
  title: string;
  description: string;
  right?: React.ReactNode;
}

export function PageHeader({ title, description, right, className }: PageHeaderProps) {
  return (
    <div className={cn('px-6 pt-12 pb-6', className)}>
      <div className="flex items-center justify-between">
        <div>
          <h2 className="mb-1 text-xl font-semibold text-zinc-900">{title}</h2>
          <p className="text-sm text-zinc-500">{description}</p>
        </div>
        {right && <div>{right}</div>}
      </div>
    </div>
  );
}
